<template>
  <v-layout align-center justify-center row fill-height>
    <WizardHeader />

    <v-flex>
      <transition-group name="slide-x-transition">
        <Welcome
          v-if="step === 'welcome'"
          key="welcome"
          @handleSetStep="handleSetStep"
          @openAccessPlatformDialog="openAccessPlatformDialog"
        />

        <Form
          v-if="step === 'form'"
          key="form"
          @handleSetStep="handleSetStep"
          @openAccessPlatformDialog="openAccessPlatformDialog"
        />

        <Sms
          v-if="step === 'sms'"
          key="sms"
          :employeesCount="employeesCount"
          :employeesList="employeesList"
          @handleSetStep="handleSetStep"
          @openAccessPlatformDialog="openAccessPlatformDialog"
        />

        <Success
          v-if="step === 'success'"
          key="success"
        />
      </transition-group>
    </v-flex>

    <SkipTutorialDialog
      :visible="skipTutorialDialog"
      @close="closeAccessPlatformDialog"
    />
  </v-layout>
</template>

<script>
import WizardHeader from 'components/wizard/Header'
import Welcome from 'components/wizard/Welcome'
import Form from 'components/wizard/Form'
import Sms from 'components/wizard/Sms'
import Success from 'components/wizard/Success'
import SkipTutorialDialog from 'components/wizard/SkipTutorialDialog'

export default {
  name: 'Wizard',
  components: {
    WizardHeader,
    Welcome,
    Form,
    Sms,
    Success,
    SkipTutorialDialog
  },
  data () {
    return {
      namespace: 'Views.Wizard',
      step: 'welcome',
      skipTutorialDialog: false,
      employeesCount: 0,
      employeesList: []
    }
  },
  methods: {
    handleSetStep ({ step, employeesCount = 0, employeesList = [] }) {
      this.step = null
      this.employeesCount = employeesCount
      this.employeesList = employeesList
      setTimeout(() => { this.step = step }, 500)
    },

    openAccessPlatformDialog () {
      this.skipTutorialDialog = true
    },

    closeAccessPlatformDialog () {
      this.skipTutorialDialog = false
    }
  }
}
</script>

<style lang="scss">
.route--wizard {

  &.logged {
    padding-left: 0;

    .v-content {
      padding-top: 0 !important;
    }
  }
}

.route--wizard.theme--light.application {

  .application--wrap {
    background-color: $gray-1;
    padding: 100px 15px 30px;

    @media (min-width: 768px) {
      padding: 60px 15px 50px;
    }

    .v-content__wrap {
      position: static;
    }
  }
}

.wizard__escape__container {
  margin: 15px 0 0;
}

.wizard__escape {
  color: $accent;

  &:hover {
    text-decoration: underline;
  }
}
</style>
